import { Config } from '../config';
import { FormTypes } from './form-types';
import { StripeMobilePayForm } from './stripe-mobile-pay-form';
import { PaymentType } from '../providers/payment-type';
import { Translations } from '../config/translations';
import { StripeGooglePayView } from '../view/stripe-google-pay-view';

export class StripeGooglePayForm extends StripeMobilePayForm {

    constructor(step: number | null = null) {
        super();
        this.step = step;
    }
    
    async init(config: Config, callback: any) {
        await super.init(config, callback);
        this.view = new StripeGooglePayView();
        this.type = FormTypes.Stripe_Google_Pay;
        this.paymentType = PaymentType.STRIPE_GOOGLE_PAY;
        this.ERROR_MESSAGE_COUNTRY_NOT_SUPPORTED = Translations.STRIPE_GOOGLE_PAY_COUNTRY_NOT_SUPPORTED;
        this.ERROR_MESSAGE_CREDIT_CARD_MISSING = Translations.STRIPE_GOOGLE_PAY_CREDIT_CARD_MISSING;
        return Promise.resolve();
    }

    shouldRenderPaymentRequestButton(result: any) {
        return result && !result.applePay;
    }

    addPaymentRequestButtonSubmitEvent() {
        const stripePaymentRequestButton = this.view.getHtmlElement('#stripe_payment_request_button');
        stripePaymentRequestButton.addEventListener('click', async (event: any) => {
            event.preventDefault();
            if (await this.config.widget.validate()) {
                this.paymentRequest.show();
            }
        });
    }

}
